import { forwardRef, useImperativeHandle, useState } from "react";

import { Checkbox } from "primereact/checkbox";

import "./CheckboxDoNotShowAgain.scss";

export type CheckboxHandle = {
  isChecked: () => boolean;
};

interface ICheckboxProps {
  inputId: string;
  checkedByDefault?: boolean;
  label?: React.ReactNode;
}

const CheckboxDoNotShowAgain = forwardRef<CheckboxHandle, ICheckboxProps>(
  ({ inputId, checkedByDefault = false, label }, ref) => {
    const [checked, setChecked] = useState<boolean>(checkedByDefault);

    // Exposes a small API so parent can read final value.
    useImperativeHandle(
      ref,
      () => ({
        isChecked: () => checked,
      }),
      [checked],
    );

    return (
      <div className="checkbox-container">
        <Checkbox inputId={inputId} checked={checked} onChange={e => setChecked(Boolean(e.checked))} />
        <label htmlFor={inputId}>{label}</label>
      </div>
    );
  },
);

CheckboxDoNotShowAgain.displayName = "CheckboxDoNotShowAgain";

export default CheckboxDoNotShowAgain;
